import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { HomeComponent } from '@formrails/home/feature';
import { FormBuilderComponent } from '@formrails/form-builder/feature';
import { SettingsComponent } from '@formrails/settings/feature';
import { WorkflowDesignerComponent } from '@formrails/workflow-designer/feature';
import { unsavedChangesGuard } from '@formrails/form-builder/data-access';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { title: 'Control Tower' },
    canActivate: [AuthGuard]
  },
  {
    path: 'form-builder',
    component: FormBuilderComponent,
    data: { title: 'Form Editor' },
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'workflows',
    component: WorkflowDesignerComponent,
    data: { title: 'Workflow Designer' },
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard]
  },
  // Was the only way to reach a blank designer; /workflows is that now. Kept so
  // existing links don't fall through to :id and ask the API for a workflow "new".
  {
    path: 'workflows/new',
    redirectTo: 'workflows',
    pathMatch: 'full'
  },
  {
    path: 'workflows/:id',
    component: WorkflowDesignerComponent,
    data: { title: 'Workflow Designer' },
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'user-management',
    loadComponent: () =>
      import('@formrails/user-management/feature-user-management').then(m => m.UserListComponent),
    data: { title: 'User Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'funder-management',
    loadComponent: () =>
      import('@formrails/funder-management/feature-funder-management').then(m => m.FunderListComponent),
    data: { title: 'Funder Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'programme-family-management',
    loadComponent: () =>
      import('@formrails/programme-family-management/feature-programme-family-management').then(
        m => m.ProgrammeFamilyListComponent
      ),
    data: { title: 'Programme Family Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'programme-type-management',
    loadComponent: () =>
      import('@formrails/programme-type-management/feature-programme-type-management').then(
        m => m.ProgrammeTypeListComponent
      ),
    data: { title: 'Programme Type Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'delivery-partner-management',
    loadComponent: () =>
      import('@formrails/delivery-partner-management/feature-delivery-partner-management').then(
        m => m.DeliveryPartnerListComponent
      ),
    data: { title: 'Delivery Partner Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'client-management',
    loadComponent: () =>
      import('@formrails/client-management/feature-client-management').then(m => m.ClientViewComponent),
    data: { title: 'Client Management' },
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: { title: 'Settings' },
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
